import { Link, LinkProps } from "../Link";
export const Hyperlink = Link;
export interface Hyperlink extends LinkProps {}
